<script lang="ts">
  import { state_fullScreen } from '../../store/state';
  import { WindowsCustomEventTypes } from '../../enums/windows-custom-event.enum';
  import { ConfigStore } from '../../store/config';
  import { _ } from 'svelte-i18n';

  let showDropdown = false;
</script>

<div class="cs-cb-multi-option-wrapper">
  <button
    on:click={() => (showDropdown = !showDropdown)}
    aria-label={$_('header.multi_option')}
    aria-controls={$_('header.multi_option')}
    title={$_('header.multi_option')}
    class="cs-type-{$ConfigStore.widgetType}"
  >
    <slot name="iconElement">
      <span class="cs-icon-settings">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M10 18C10 15.7909 8.20914 14 6 14C3.79086 14 2 15.7909 2 18C2 20.2091 3.79086 22 6 22C8.20914 22 10 20.2091 10 18Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10C20.2091 10 22 8.20914 22 6Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
      </span>
    </slot>
  </button>

  <div
    class="cs-cb-multi-option"
    tabindex="-1"
    role="button"
    on:click={() => (showDropdown = false)}
    on:keydown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        showDropdown = false;
      }
    }}
  >
    <slot name="dropdownElement">
      <span class="cs-cb-multi-option-list">
        <button
          aria-label={$_('header.toggle_resize')}
          aria-controls={$_('header.toggle_resize')}
          title={$_('header.toggle_resize')}
          on:click={() => {
            window.dispatchEvent(
              new CustomEvent(WindowsCustomEventTypes.toggleFullScreen, {
                detail: !$state_fullScreen,
              })
            );
          }}
        >
          {$state_fullScreen ? 'Minimize' : 'Maximize'}
        </button>
      </span>

      {#if $ConfigStore?.additionalLink && $ConfigStore?.additionalLink.length > 0}
        {#each $ConfigStore.additionalLink as additionalLink}
          <span class="cs-cb-multi-option-list">
            <a href={additionalLink.url}>{additionalLink.title}</a>
          </span>
        {/each}
      {/if}
    </slot>
  </div>
</div>

<style lang="scss">
  @use './../../../scss/components/themes/multi-option-theme';
</style>
